// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa1.dev.cmona.de/auto-open-api-spec.yaml 1.9.0
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Base Serializer for all Serializer implementations in Terminology.
 * @see #/components/schemas/MedicationTerminologyUpdateRequest - reference to schema in open-api-spec.yaml
 * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
 * @version 1.9.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface MedicationTerminologyUpdateRequest {
    /**
     * The display name of Medicine
     *
     */
    display_name: string;
    /**
     * The practitioner.
     * @dataFormat uuid
     */
    last_changed_by: string;
    /**
     * The medication group Id.
     * @dataFormat uuid
     */
    group: string;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for MedicationTerminologyUpdateRequest
 */
export namespace MedicationTerminologyUpdateRequest {
    /**
     * MedicationTerminologyUpdateRequest Frontend Model with camelCase properties
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * The display name of Medicine
         * @type string (`dataFormat` is missing)
         */
        displayName: string;
        /**
         * The practitioner.
         * @dataFormat uuid
         */
        lastChangedBy: string;
        /**
         * The medication group Id.
         * @dataFormat uuid
         */
        group: string;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * MedicationTerminologyUpdateRequest DTO
     * Transforms MedicationTerminologyUpdateRequest model from/to API object
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend MedicationTerminologyUpdateRequest model */
        static toModel(obj: MedicationTerminologyUpdateRequest): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend MedicationTerminologyUpdateRequest model */
        static toApi(obj: Model): MedicationTerminologyUpdateRequest {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as MedicationTerminologyUpdateRequest;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
